import gql from 'graphql-tag';

export const GET_USER = gql`
  query GetUser($userId: ID) {
    User(id: $userId) {
      id
      name
    }
  }
`;

export const GET_LATEST_RELEASES = gql`
  query GetLatestReleases($limit: Int, $lastEvaluatedKey: String, $type: RELEASE_TYPE) {
    superAdminViewer {
      latestReleases(limit: $limit, lastEvaluatedKey: $lastEvaluatedKey, type: $type) {
        items {
          id
          titleLang
          bodyLang
          createdAt
          createdBy
          updatedAt
          imageUrls
          productTags
          type
          notes {
            titleLang
            showToCustomers
            imageUrls
            companyIds
          }
        }
        lastEvaluatedKey
      }
    }
  }
`;

export const GET_RELEASE = gql`
  query GetRelease($id: String!) {
    superAdminViewer {
      Release(id: $id) {
        id
        titleLang
        bodyLang
        createdAt
        createdBy
        imageUrls
        notes {
          titleLang
          showToCustomers
          imageUrls
          companyIds
        }
        productTags
        type
        updatedAt
        repository
        triggerModal
      }
    }
  }
`;

export const GET_ALL_COMPANIES = gql`
  query GetAllCompaniesForReleases {
    allCompanies(filter: { active: true }) {
      id
      name
    }
  }
`;
